module.exports = __webpack_public_path__ + "img/icon-homepage-country-data-light-16.54854d2.svg";